import { IAprovarColetaPrecoFornecedorUseCase } from "../../../presentation/useCases/update/aprovar_coleta_preco_fornecedor_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * AprovarColetaPrecoFornecedorUseCase
 */

export class AprovarColetaPrecoFornecedorUseCase implements IAprovarColetaPrecoFornecedorUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async aprovarColetaPrecoFornecedor(
    idColetaPrecoFornecedor: number,
    idFuncionarioAprovador: number,
  ): Promise<void> {
    await this.repository.aprovarColetaPrecoFornecedor(
      idColetaPrecoFornecedor,
      idFuncionarioAprovador,
    );
  }
}
